import { render, staticRenderFns } from "./uploadCardBill.vue?vue&type=template&id=684ff225&scoped=true&"
import script from "./uploadCardBill.vue?vue&type=script&lang=js&"
export * from "./uploadCardBill.vue?vue&type=script&lang=js&"
import style0 from "./uploadCardBill.vue?vue&type=style&index=0&id=684ff225&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ff225",
  null
  
)

export default component.exports